import posthog from 'app/utils/posthog'

export default {
  install(Vue, options) {
    Vue.prototype.$posthog = posthog
  }
}
